import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonEN from '@/assets/i18n/en/common';
import loginPageEN from '@/assets/i18n/en/loginPage';
import mediaPlanPageEN from '@/assets/i18n/en/mediaPlanPage';
import userSettingsPageEN from '@/assets/i18n/en/userSettingsPage';
import rateCardsPageEN from '@/assets/i18n/en/rateCardsPage';
import bookingSheetPageEN from '@/assets/i18n/en/bookingSheetPage';
import { NAMESPACE } from '@/constants';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      [NAMESPACE.COMMON]: commonEN,
      [NAMESPACE.LOGIN_PAGE]: loginPageEN,
      [NAMESPACE.MEDIA_PLAN_PAGE]: mediaPlanPageEN,
      [NAMESPACE.USER_SETTINGS_PAGE]: userSettingsPageEN,
      [NAMESPACE.RATE_CARDS_PAGE]: rateCardsPageEN,
      [NAMESPACE.BOOKING_SHEET_PAGE]: bookingSheetPageEN
    }
  },
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: NAMESPACE.COMMON,
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
